export default "__VITE_ASSET__nmIY32u7__"